import React from "react";
import styled from "styled-components";
import { Icon } from "react-icons-kit";
import { twitter } from "react-icons-kit/fa/twitter";

const CallToAction = ({ context }) => {
  const { title, location, isPublished } = context;

  if (process.env.NODE_ENV === "production" && !isPublished) {
    return null;
  }

  const currentUrl = location.origin + location.pathname;
  const shareMessage = `“${title}”, a post by Craig Ferguson. `;
  const href = generateUrl(currentUrl, shareMessage);

  return (
    <Wrapper>
      <Corner>
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          style={{ display: "relative " }}
        >
          <Icon
            style={{
              transform: "translate(5px, 5px)",
              display: "flex",
              alignItems: "center",
              color: "var(--color-primary)"
            }}
            icon={twitter}
            size={25}
          />
        </a>
      </Corner>
      <Content>
        Thanks for making it to the end; I hope you picked up something useful.
        If you think it would help others in your network, I'd appreciate it if
        you{" "}
        <ShareLink href={href} target="_blank" rel="noreferrer">
          shared it
        </ShareLink>{" "}
        with them.
      </Content>
    </Wrapper>
  );
};

const generateUrl = (shareUrl, message) => {
  const text = encodeURIComponent(message);

  return `https://twitter.com/share?url=${shareUrl}&text=${text}&via=_craigfe`;
};

const Wrapper = styled.aside`
  position: relative;

  background: var(--color-foreground);
  transition: background 0.25s linear;
  border-radius: 0.3em;
  border-left: 4px solid var(--color-primary);

  padding: 24px 16px;
  margin-left: -16px;
  margin-right: -16px;
`;

const ShareLink = styled.a`
  border-bottom: medium solid var(--color-primary-half) !important;

  & :hover {
    border-bottom: medium solid var(--color-primary) !important;
  }
`;

const Corner = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  transform: translate(-50%, -50%);
  padding: 9px;
  background: var(--color-background);
  transition: background 0.25s linear;
  border-radius: 50%;
`;

const Content = styled.div`
  padding: 0 7px;
`;

export default CallToAction;
